export default __webpack_public_path__ + "static/media/dimg10.7635b7c9.jpg";